import { render, staticRenderFns } from "./ShoppingList.vue?vue&type=template&id=86a9eb34&scoped=true"
import script from "./ShoppingList.vue?vue&type=script&lang=js"
export * from "./ShoppingList.vue?vue&type=script&lang=js"
import style0 from "./ShoppingList.vue?vue&type=style&index=0&id=86a9eb34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86a9eb34",
  null
  
)

export default component.exports